import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rbxatpcasybysywbddvh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJieGF0cGNhc3lieXN5d2JkZHZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjczOTIyMTAsImV4cCI6MjA4Mjk2ODIxMH0.t4SQYPQrgzwvv27AlWNS2ZfOUC0UX-lq88bh9lxd8Vs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

